import React from 'react';
import { XControl } from '../../commons';
import { IComboBoxItemProps } from './IComboBoxItemProps';
import { IComboBoxItemState } from './IComboBoxItemState';
import {v4 as uuid} from 'uuid';


export class XComboBoxItem extends XControl<HTMLInputElement, IComboBoxItemProps, IComboBoxItemState> {
    static defaultProps = {
        ...XControl.defaultProps,
        id: { uuid },
        default: undefined,
        className: undefined,
        onMouseDown: null,
        onClick: null
    };
    public constructor(props: IComboBoxItemProps) {
        super(props);
    }
    public componentDidMount(): void {
        super.componentDidMount();
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
    }
    public render(): React.ReactNode {
        return (
            <div className={this.props.className}
                key={this.props.id}
                onMouseDown={this.props.onMouseDown}
                onClick={() => this.props.onClick?.(this)}
                data-value={this.props.value}>
                {this.props.children}
            </div>
        );
    }
}
